module.exports = __webpack_public_path__ + "static/media/maingreen.1d0009c9.svg";